import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const MainGuard = ({ children }) => {
  const location = useLocation();
  const statusData = useSelector((state) => state.user.statusData);
  const { user_progress } = statusData;

  return useMemo(() => {
    if (statusData.bear_type === null) {
      // 沒選過熊
      return <Navigate to="/loginAnimation" replace />;
    }

    if (
      user_progress.some((item) => item.progress == 1) &&
      location.pathname !== "/lottery"
    ) {
      // 有新解鎖的裝備
      return <Navigate to="/lottery" replace />;
    }

    return children;
  }, []);
};

export default MainGuard;
